import { useState } from "react";
import ButtonControl from "../../../../../components/controls/ButtonControl";
import FileUploaderControl from "../../../../../components/controls/FileUploaderControl";
import { InputField } from "../../../../../components/controls/InputField";
import "../details.scss";
import { TagPicker } from "rsuite";
import _ from "lodash";
import { SelectListControl } from "../../../../../components/controls";
import { useEffect } from "react";
import {
  getFieldName,
  getPosition,
  getValue,
} from "../../../../../utilities/ObservationConfigUtils";

export default function ObservationSettings({
  downloadMgr,
  name,
  observationConfig,
  updateObservationConfigs,
  forceValidate,
  showCertPositions,
  formattedTeacherCertificationRubrics,
  defaultUserPositionTypes,
  orgTreeUsers,
}) {
  const [fileLoading, setFileLoading] = useState(false);
  const [formattedUserEmailMap, setFormattedUserEmailMap] = useState([]);

  useEffect(() => {
    //Filter out emails not in system.
    const outsideEmails = _.map(
      _.filter(
        getValue(observationConfig, name, "Certification*Emails"),
        (x) => {
          if (!_.find(orgTreeUsers, (y) => y.Email === x)) {
            return true;
          }
        }
      ),
      (z) => {
        return {
          label: z,
          value: z,
        };
      }
    );
    setFormattedUserEmailMap(
      outsideEmails.concat(
        _.map(orgTreeUsers, (x) => {
          return {
            label: x.Name,
            value: x.Email,
          };
        })
      )
    );
  }, [orgTreeUsers, name, observationConfig]);

  const handleResetFile = (name) => {
    //Clears fires a confirm dialog and clears the file.
    sessionStorage.removeItem(`FileUpload-logo-question-${name}-certification`);
    updateObservationConfigs(null, `CertificationLog${name}FileId`);
  };

  const handleDownloadFile = async () => {
    const fileId = getValue(
      observationConfig,
      name,
      "CertificationLog*File"
    )?.Id;
    const fileName = `${getValue(observationConfig, name, "CertificationLog*File")?.DisplayFileName}.${
      getValue(observationConfig, name, "CertificationLog*File")?.FileExtention
    }`;
    await downloadMgr.getFile(fileId, fileName);
  };
  const handleEmails = (value, event) => {
    const emailRgx =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (event.code === "Enter" && event.target.value.match(emailRgx)) {
      const spreadEmailArray = getValue(
        observationConfig,
        name,
        "Certification*Emails"
      )
        ? [...getValue(observationConfig, name, "Certification*Emails")]
        : [];
      updateObservationConfigs(
        [...spreadEmailArray, event.target.value],
        getFieldName(name, "Certification*Emails")
      );
      setFormattedUserEmailMap([
        ...formattedUserEmailMap,
        {
          label: event.target.value,
          value: event.target.value,
        },
      ]);
    } else {
      updateObservationConfigs(
        value,
        getFieldName(name, "Certification*Emails")
      );
    }
  };
  return (
    <div className="admin-cert-config-wrapper">
      {/* TODO create validation object for organization */}
      <div className="admin-cert-config-left-col">
        {name === "Teacher" && (
          <>
            {
              <InputField
                subTitle={"Rubric"}
                value={observationConfig?.CertificationRubricId}
                fieldName={"CertificationRubricId"}
                onChange={(value, fieldName) =>
                  updateObservationConfigs(value, fieldName)
                }
              >
                <SelectListControl
                  textValuePairs={formattedTeacherCertificationRubrics}
                  hidePleaseSelect={false}
                />
              </InputField>
            }
            <InputField
              forceValidate={forceValidate}
              subTitle={"Part I: Number of ratings allowed off by +2"}
              fieldName={getFieldName(name, "CertificationRatingOffBy2*")}
              value={getValue(
                observationConfig,
                name,
                "CertificationRatingOffBy2*"
              )}
              onChange={updateObservationConfigs}
            />
            <InputField
              forceValidate={forceValidate}
              subTitle={"Part I: Number of ratings allowed off by +3"}
              fieldName={getFieldName(name, "CertificationRatingOffBy3*")}
              value={getValue(
                observationConfig,
                name,
                "CertificationRatingOffBy3*"
              )}
              onChange={updateObservationConfigs}
            />
          </>
        )}
        <InputField
          forceValidate={forceValidate}
          subTitle={
            (name === "Teacher" ? "Part II: " : "") +
            "Total Number of Questions"
          }
          fieldName={getFieldName(name, "NumberOfQuestions*Cert")}
          value={getValue(observationConfig, name, "NumberOfQuestions*Cert")}
          onChange={updateObservationConfigs}
        />
        <InputField
          forceValidate={forceValidate}
          subTitle={
            (name === "Teacher" ? "Part II: " : "") +
            "Total Correct Questions Needed to Pass"
          }
          fieldName={getFieldName(name, "NumberToPass*Cert")}
          value={getValue(observationConfig, name, "NumberToPass*Cert")}
          onChange={updateObservationConfigs}
        />
        <InputField
          forceValidate={forceValidate}
          subTitle="Lockout Period (Days)"
          fieldName={getFieldName(name, "DaysUntillRetry*Cert")}
          value={getValue(observationConfig, name, "DaysUntillRetry*Cert")}
          onChange={updateObservationConfigs}
        />
        {name === "Teacher" && (
          <InputField
            forceValidate={forceValidate}
            subTitle="Part I: Maximum Attempts Part 1"
            fieldName={"CertificationRetryAttemptsTeacherPart1"}
            value={observationConfig?.CertificationRetryAttemptsTeacherPart1}
            onChange={updateObservationConfigs}
          />
        )}
        <InputField
          forceValidate={forceValidate}
          subTitle={
            (name === "Teacher" ? "Part II: " : "") +
            `Maximum Attempts` +
            (name === "Teacher" ? " Part 2" : "")
          }
          fieldName={getFieldName(name, "CertificationRetryAttempts*")}
          value={getValue(
            observationConfig,
            name,
            "CertificationRetryAttempts*"
          )}
          onChange={updateObservationConfigs}
        />
        {showCertPositions && (
          <InputField subTitle="Certifiable Positions">
            <TagPicker
              key={name}
              className="tag-picker"
              data={getPosition(1, 99, defaultUserPositionTypes)}
              defaultValue={getValue(
                observationConfig,
                name,
                "CertificationUserPositions*"
              )}
              onChange={(value) =>
                updateObservationConfigs(
                  value,
                  `CertificationUserPositions${name}`
                )
              }
              block
              preventOverflow
            />
          </InputField>
        )}

        <InputField
          forceValidate={forceValidate}
          subTitle="Certifications Email Recipient"
        >
          <TagPicker
            key={name}
            data={formattedUserEmailMap}
            defaultValue={getValue(
              observationConfig,
              name,
              "Certification*Emails"
            )}
            valueKey={"value"}
            onChange={handleEmails}
          />
        </InputField>
      </div>
      <div className="admin-cert-config-right-col">
        <InputField
          forceValidate={forceValidate}
          subTitle="Name of Certification"
          fieldName={getFieldName(name, "CertificationName*")}
          value={getValue(observationConfig, name, "CertificationName*")}
          onChange={updateObservationConfigs}
        />
        <InputField
          forceValidate={forceValidate}
          subTitle="Certification Title"
          fieldName={getFieldName(name, "CertificationTitle*")}
          value={getValue(observationConfig, name, "CertificationTitle*")}
          onChange={updateObservationConfigs}
        />
        <InputField
          title="Certification Logo"
          forceValidate={forceValidate}
          value={getValue(observationConfig, name, "CertificationLog*FileId")}
          onChange={(value) =>
            updateObservationConfigs(
              value,
              getFieldName(name, "CertificationLog*FileId")
            )
          }
          fieldName={getFieldName(name, "CertificationLog*FileId")}
          subTitle={
            "Drag into or click the box below to upload the certification logo."
          }
        >
          <FileUploaderControl
            canUploadAnyFile={true}
            controlId={`logo-question-${name}-certification`}
            value={getValue(observationConfig, name, "CertificationLog*FileId")}
            fileUrl={
              getValue(observationConfig, name, "CertificationLog*File")
                ?.FileUrl
            }
            overrideMaxWidth={350}
            widthRes={1920}
            heightRes={1080}
            maxFileSize={1024 * 1024 * 99}
            onFileLoading={(val) => setFileLoading(val)}
          />
        </InputField>
        {!(
          getValue(observationConfig, name, "CertificationLog*FileId") ===
            null ||
          getValue(observationConfig, name, "CertificationLog*FileId") ===
            undefined
        ) && (
          <div className="reset-file-btn">
            <ButtonControl onClick={() => handleResetFile(name)}>
              Reset File
            </ButtonControl>
            {getValue(observationConfig, name, "CertificationLog*File")
              ?.FileUrl && (
              <ButtonControl
                type={"okay"}
                loading={fileLoading}
                onClick={() => handleDownloadFile()}
              >
                Download
              </ButtonControl>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
